<template>
  <div class="container-fluid">
    <div class="card animated fadeIn">
      <b-row>
        <b-col sm="9">
          <b-card>
            <div slot="header">
              <strong>Add Config</strong>
            </div>
            <div>
              <div>
                <div v-if="!loading">
                  <b-form @submit.prevent="updateConfig()">
                    <!-- <pre>index: {{this.config}} </pre> -->
                    <b-form-group label="Name of Config:" label-for="name">
                      <b-form-input
                        type="text"
                        v-model="config.name"
                        v-validate="'required'"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && verrors.has('name'),
                        }"
                      ></b-form-input>
                      <div
                        v-if="submitted && verrors.has('name')"
                        class="invalid-feedback"
                      >
                        {{ verrors.first("name") }}
                      </div>
                    </b-form-group>
                    <b-form-group label="Models:" label-for="models">
                      <multiselect
                        v-model="value"
                        :options="options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="false"
                        placeholder="search ..."
                        :show-labels="false"
                        label="name"
                        track-by="id"
                        :preselect-first="false"
                        :hideSelected="false"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, search }"
                        >
                          <!-- <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Model selected</span> -->
                        </template>
                      </multiselect>
                    </b-form-group>
                    <!-- 

                    <b-form-group label="Snippet" label-for="snippet" :label-cols-sm="2">
                      <b-form-textarea max-rows="8" v-model="config.snippet" v-validate="'required'" id="snippet" name="snippet" class="form-control" :class="{ 'is-invalid': submitted && verrors.has('snippet') }" @keydown.tab.prevent="tabber($event)"></b-form-textarea>
                      <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('snippet') }}</div>
                    </b-form-group>

                     -->
                    <span>Configuration:</span>
                    <network
                      :config="config"
                   
                      :changed="changed"
                      :changes="changes"
                    ></network>
                  </b-form>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col sm=3>
          <b-card>
            <div slot="header">
              <strong>Config Changes</strong>
            </div>
            <ul id="eg1">
              <li v-for="change in this.changed" v-bind:key="change.param">
                {{ change.name }} : {{ change.value }}
              </li>
            </ul>
            <div class="text-center">
              <button
                v-if="kount"
                class="btn btn-primary"
                @click.prevent="updateConfig"
              >
                Create Config
              </button>
              <!-- <button v-if="kount" class="btn btn-secondary" @click.prevent="onReset">Reset</button> -->
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<!--
default vale: https://michaelstivala.com/setting-the-default-value-of-a-select-tag-in-vuejs/
https://medium.com/@hugodesigns/how-to-use-the-most-complete-selecting-solution-for-vue-js-f991b2605364
https://medium.com/employbl/build-tagging-with-vue-multiselect-and-laravel-tags-960c260df438

saving selected tags:
https://quickadminpanel.com/blog/add-tags-to-articles-laravel-many-to-many-relationships-with-select2/

for selected tags using only ids:
https://github.com/shentao/vue-multiselect/issues/133
-->


<script>
import Multiselect from "vue-multiselect";
import Network from "@/readynet/configs/network/index";

export default {
  components: {
    Multiselect,
    network: Network,
  },
  data() {
    return {
      config:{},


      changed: [], // {param: "radio0_country", value: "", name: "Radio 0 Reg Domaini"},
      changes: {},
      submitted: false,
      value: [],
      options: [],
      selectedIds: [],
      loading: false,
    };
  },
  // https://github.com/shentao/vue-multiselect/issues/263
  watch: {
    value(newValues) {
      this.selectedIds = newValues.map((obj) => obj.id);
    },
  },

  created() {
    this.loading = true;
    let uri = `/api/configs/create`;
    axios.get(uri).then((response) => {
      // this.config = response.data.data.config;
      this.config.snippet = response.data.data.emptySnippet;
      this.options = response.data.data.all_prod_tags;
      // this.value = response.data.data.my_prod_tags;
      this.loading = false;
    });
  },
  computed: {
    optionsArray() {
      return Object.keys(this.options).map((i) => this.options[i]);
    },
    kount: function () {
      return this.changed.length;
    },
  },

  methods: {
    /**
     * Deep diff between two object, using lodash
     * @param  {Object} object Object compared
     * @param  {Object} base   Object to compare with
     * @return {Object}        Return a new object who represent the diff
     */
    difference(object, base) {
      return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
          result[key] =
            isObject(value) && isObject(base[key])
              ? difference(value, base[key])
              : value;
        }
      });
    },

    // toArray(obj_obj) {
    //   return Object.keys(obj_obj).map(i => obj_obj[i]);
    // },

    updateConfig() {
      this.submitted = true;
      // this.config.product_list =[21];
      this.config.product_list = this.selectedIds;
      JSON.stringify(this.config);
      this.$validator.validate().then((valid) => {
        if (valid) {
          let uri = `/api/configs/`;
          axios.post(uri, this.config).then((response) => {
            if (response.data.success === true) {
              this.makeToast("info", "Config added.");
            } else {
              this.makeToast("danger", "Unable to update config.");
            }
          });
        }
      });
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Config Updated ${variant || 'default'}`,
        title: `Notification:`,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
      // toast.show();
    },

    tabber(event) {
      let text = this.config.snippet,
        originalSelectionStart = event.target.selectionStart,
        textStart = text.slice(0, originalSelectionStart),
        textEnd = text.slice(originalSelectionStart);

      this.config.snippet = `${textStart}\t${textEnd}`;
      event.target.value = this.config.snippet; // required to make the cursor stay in place.
      event.target.selectionEnd = event.target.selectionStart =
        originalSelectionStart + 1;
    },
  },
};
</script>

<style>
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #20a8d8;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.multiselect__option--highlight {
  background: #20a8d8;
  outline: none;
  color: white;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #20a8d8;
  color: white;
}
</style>
